/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ESickNoteCaseStatus } from '../models/ESickNoteCaseStatus';
import type { ESickNoteDpnAttendingDoctorSchema } from '../models/ESickNoteDpnAttendingDoctorSchema';
import type { ESickNoteDpnCaseClosureSchema } from '../models/ESickNoteDpnCaseClosureSchema';
import type { ESickNoteDpnCaseCreateSchema } from '../models/ESickNoteDpnCaseCreateSchema';
import type { ESickNoteDpnCaseDetailSchema } from '../models/ESickNoteDpnCaseDetailSchema';
import type { ESickNoteDpnCaseDurationConfirmationSchema } from '../models/ESickNoteDpnCaseDurationConfirmationSchema';
import type { ESickNoteDpnCaseReportSchema } from '../models/ESickNoteDpnCaseReportSchema';
import type { ESickNoteDpnCsszCaseDetailSchema } from '../models/ESickNoteDpnCsszCaseDetailSchema';
import type { ESickNoteDpnCsszCaseSchema } from '../models/ESickNoteDpnCsszCaseSchema';
import type { ESickNoteDpnPatientAddressSchema } from '../models/ESickNoteDpnPatientAddressSchema';
import type { ESickNoteDpnPatientEmploymentSchema } from '../models/ESickNoteDpnPatientEmploymentSchema';
import type { ESickNoteDpnUnclosedCsszCaseSchema } from '../models/ESickNoteDpnUnclosedCsszCaseSchema';
import type { ESickNoteRequestCreateSchema } from '../models/ESickNoteRequestCreateSchema';
import type { ESickNoteRequestDetailSchema } from '../models/ESickNoteRequestDetailSchema';
import type { ESickNoteSubmissionDetailSchema } from '../models/ESickNoteSubmissionDetailSchema';
import type { ESickNoteSubmissionStatus } from '../models/ESickNoteSubmissionStatus';
import type { PagedESickNoteDpnCaseDetailSchema } from '../models/PagedESickNoteDpnCaseDetailSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EsickNotesDpnApi {
    /**
     * Get Esick Note Dpn Cssz Case List
     * List the sick leave cases ČSSZ has registered for this identity (ČSSZ VratPripadyDleIcpe). Required Permission: create_esick_note
     * @returns ESickNoteDpnCsszCaseSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnCsszCaseListGet({
        identityId,
    }: {
        identityId: string,
    }): CancelablePromise<Array<ESickNoteDpnCsszCaseSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/identities/{identity_id}/cases/',
            path: {
                'identity_id': identityId,
            },
        });
    }
    /**
     * Get Esick Note Dpn Cssz Case Detail
     * Get a single ČSSZ case as registered for this identity (ČSSZ VratDetailPripadu). Required Permission: create_esick_note
     * @returns ESickNoteDpnCsszCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnCsszCaseDetailGet({
        identityId,
        decisionNumber,
    }: {
        identityId: string,
        decisionNumber: string,
    }): CancelablePromise<ESickNoteDpnCsszCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/identities/{identity_id}/cases/{decision_number}/',
            path: {
                'identity_id': identityId,
                'decision_number': decisionNumber,
            },
        });
    }
    /**
     * Set Esick Note Dpn Attending Doctor
     * Take a sick note issued by another doctor into this identity's care and start tracking it locally (ČSSZ Hol PrevzetiDoPece). Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnSetEsickNoteDpnAttendingDoctorPut({
        identityId,
        decisionNumber,
        requestBody,
    }: {
        identityId: string,
        decisionNumber: string,
        requestBody: ESickNoteDpnAttendingDoctorSchema,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/dpn/identities/{identity_id}/cases/{decision_number}/attending-doctor/',
            path: {
                'identity_id': identityId,
                'decision_number': decisionNumber,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Unclosed Esick Note Dpn Cssz Case List
     * Search ČSSZ for sick notes that are still open, including ones issued by other doctors, by patient national id or decision number. Used before taking a patient into care (ČSSZ VratNeukonceneDpn). Required Permission: create_esick_note
     * @returns ESickNoteDpnUnclosedCsszCaseSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetUnclosedEsickNoteDpnCsszCaseListGet({
        identityId,
        patientNin,
        decisionNumber,
    }: {
        identityId: string,
        patientNin?: (string | null),
        decisionNumber?: (string | null),
    }): CancelablePromise<Array<ESickNoteDpnUnclosedCsszCaseSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/identities/{identity_id}/unclosed-cases/',
            path: {
                'identity_id': identityId,
            },
            query: {
                'patient_nin': patientNin,
                'decision_number': decisionNumber,
            },
        });
    }
    /**
     * Get Esick Note Dpn Patient Addresses
     * Look up the insured person's registered addresses to prefill a new sick note (ČSSZ VratAdresuPojistence). Required Permission: create_esick_note
     * @returns ESickNoteDpnPatientAddressSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnPatientAddressesGet({
        identityId,
        patientNin,
    }: {
        identityId: string,
        patientNin: string,
    }): CancelablePromise<Array<ESickNoteDpnPatientAddressSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/identities/{identity_id}/patient-addresses/',
            path: {
                'identity_id': identityId,
            },
            query: {
                'patient_nin': patientNin,
            },
        });
    }
    /**
     * Get Esick Note Dpn Patient Employments
     * Look up the insured person's employments to prefill a new sick note (ČSSZ VratZamestnavatelePojistence). Required Permission: create_esick_note
     * @returns ESickNoteDpnPatientEmploymentSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnPatientEmploymentsGet({
        identityId,
        patientNin,
    }: {
        identityId: string,
        patientNin: string,
    }): CancelablePromise<Array<ESickNoteDpnPatientEmploymentSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/identities/{identity_id}/patient-employments/',
            path: {
                'identity_id': identityId,
            },
            query: {
                'patient_nin': patientNin,
            },
        });
    }
    /**
     * Create Esick Note Dpn Case
     * Issue a new sick note and submit it to ČSSZ (ČSSZ Rdpn1). Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteDpnCreateEsickNoteDpnCasePost({
        requestBody,
    }: {
        requestBody: ESickNoteDpnCaseCreateSchema,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/dpn/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Dpn Case List
     * List sick notes issued by the logged-in user's company. Required Permission: create_esick_note
     * @returns PagedESickNoteDpnCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnCaseListGet({
        patientId,
        submissionStatus,
        caseStatus,
        limit = 100,
        offset,
    }: {
        patientId?: (string | null),
        submissionStatus?: (ESickNoteSubmissionStatus | null),
        caseStatus?: (ESickNoteCaseStatus | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/',
            query: {
                'patient_id': patientId,
                'submission_status': submissionStatus,
                'case_status': caseStatus,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get Esick Note Dpn Case
     * Get sick note detail. Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnCaseGet({
        dpnCaseId,
    }: {
        dpnCaseId: string,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
        });
    }
    /**
     * Set Esick Note Dpn Case Closure
     * End the sick note and report it to ČSSZ. Repeating the call submits a correction (ČSSZ Rdpn3). Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnSetEsickNoteDpnCaseClosurePut({
        dpnCaseId,
        requestBody,
    }: {
        dpnCaseId: string,
        requestBody: ESickNoteDpnCaseClosureSchema,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/closure/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Esick Note Dpn Case Duration Confirmation
     * Confirm that the incapacity still lasts as of a given date (ČSSZ Ptdpn). Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnSetEsickNoteDpnCaseDurationConfirmationPut({
        dpnCaseId,
        requestBody,
    }: {
        dpnCaseId: string,
        requestBody: ESickNoteDpnCaseDurationConfirmationSchema,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/duration-confirmation/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Esick Note Dpn Case Report
     * Submit an attending doctor's report bundling any combination of address, diagnosis, regime, outings, hospitalization and doctor-handover changes (ČSSZ Hol). The report is stored with the submission history and reflected in the sick note's current state, which is returned. Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteDpnCreateEsickNoteDpnCaseReportPost({
        dpnCaseId,
        requestBody,
    }: {
        dpnCaseId: string,
        requestBody: ESickNoteDpnCaseReportSchema,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/reports/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Esick Note Dpn Case Request
     * Send a žádost ošetřujícího lékaře (ZOLUSU/ZOLUSOU/ZUSPVY/ZPNPUS) for this eNeschopenka. ČSSZ only confirms receipt; the decision arrives later as a notification. Required Permission: create_esick_note
     * @returns ESickNoteRequestDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteDpnCreateEsickNoteDpnCaseRequestPost({
        dpnCaseId,
        requestBody,
    }: {
        dpnCaseId: string,
        requestBody: ESickNoteRequestCreateSchema,
    }): CancelablePromise<ESickNoteRequestDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/requests/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Dpn Case Request List
     * List the žádosti ošetřujícího lékaře sent for this eNeschopenka, with the state ČSSZ last reported. Required Permission: create_esick_note
     * @returns ESickNoteRequestDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnCaseRequestListGet({
        dpnCaseId,
    }: {
        dpnCaseId: string,
    }): CancelablePromise<Array<ESickNoteRequestDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/requests/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
        });
    }
    /**
     * Sync Esick Note Dpn Case From Cssz
     * Read the sick note back from ČSSZ now and update its case state, end, confirmed duration and takeover (ČSSZ VratDetailPripadu); the same runs daily for every DPN ČSSZ may still change. Required Permission: create_esick_note
     * @returns ESickNoteDpnCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnSyncEsickNoteDpnCaseFromCsszPost({
        dpnCaseId,
    }: {
        dpnCaseId: string,
    }): CancelablePromise<ESickNoteDpnCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/cssz-sync/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
        });
    }
    /**
     * Get Esick Note Dpn Case Submission List
     * List every podání ČSSZ accepted for this eNeschopenka, newest first, with what was sent and the state ČSSZ last reported. Required Permission: create_esick_note
     * @returns ESickNoteSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteDpnGetEsickNoteDpnCaseSubmissionListGet({
        dpnCaseId,
    }: {
        dpnCaseId: string,
    }): CancelablePromise<Array<ESickNoteSubmissionDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/dpn/{dpn_case_id}/submissions/',
            path: {
                'dpn_case_id': dpnCaseId,
            },
        });
    }
}
